import React from "react"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { cmsPageClick } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type {
  GeneralBynderAsset,
  GeneralLink,
  LivePromoTileType,
  ReducedGeneralLink,
  ReducedImage,
} from "types/cms"

import { Link } from "components/Link"
import { Tile } from "./Tile"

type Props = CMSPageProps & LivePromoTileType

export const LivePromoTile: React.FC<Props> = ({
  image,
  contentBlocks,
  cta,
  darkenImage,
  trackingModule,
  link,
}) => {
  const src =
    (image as GeneralBynderAsset)?.bynderData?.[0]?.thumbnails?.["OTF BETA"] ??
    (image as ReducedImage)?.src ??
    "/images/placeholders/800x800.svg"

  const alt =
    (image as GeneralBynderAsset)?.description ??
    (image as ReducedImage)?.description ??
    "image"

  const title =
    (image as GeneralBynderAsset)?.filename ??
    (image as ReducedImage)?.filename ??
    "image.jpg"

  if (link) {
    const linkToPass =
      (link as ReducedGeneralLink).href ?? (link as GeneralLink).url
    return (
      <Link
        href={linkToPass}
        title={link.title}
        onClick={() =>
          cmsPageClick({
            ...trackingModule,
            moduleContentUrl: linkToPass,
          })
        }
      >
        <Tile
          src={src}
          alt={alt}
          title={title}
          contentBlocks={contentBlocks}
          darkenImage={darkenImage}
          cta={cta}
          trackingModule={trackingModule}
        />
      </Link>
    )
  }
  return (
    <Tile
      src={src}
      alt={alt}
      title={title}
      contentBlocks={contentBlocks}
      darkenImage={darkenImage}
      cta={cta}
      trackingModule={trackingModule}
    />
  )
}
